import React, { useState } from "react";

function Inference() {
  const [selectedOption, setSelectedOption] = useState("");

  const options = [
    "Early stage investment experience",
    "Experienced as a serial entrepreneur",
    "Senior management professional with 10 years of experience or more",
    "None of the above",
  ];

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      {/* Heading */}
      <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 text-center mb-6">
        Help us to understand your experience better
      </h1>

      {/* Options */}
      <form className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
        {options.map((option, index) => (
          <div key={index} className="flex items-center mb-4">
            <input
              type="radio"
              id={`option-${index}`}
              name="experience"
              value={option}
              checked={selectedOption === option}
              onChange={() => handleOptionChange(option)}
              className="w-5 h-5 text-orange-400 focus:ring-orange-300 focus:outline-none"
            />
            <label
              htmlFor={`option-${index}`}
              className="ml-2 text-sm sm:text-base md:text-lg lg:text-xl font-medium text-gray-800"
            >
              {option}
            </label>
          </div>
        ))}

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-orange-400 text-white text-sm sm:text-base md:text-lg lg:text-xl font-bold py-2 px-4 rounded-lg hover:bg-orange-500 transition-colors"
        >
          Submit
        </button>
      </form>
    </div>
  );
}

export default Inference;
